import { createContext, useContext } from 'react';
import { AuthenticationInfo } from '@/model/auth';

export interface IAuthContext {
  authenticationInfo: AuthenticationInfo | null;
  logout(): void;
  login(authenticationInfo: AuthenticationInfo): void;
}

export const AuthContext = createContext<IAuthContext>(null as unknown as IAuthContext);

export const useAuthContext = (): IAuthContext => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error('useAuthContext must be used within AuthContextProvider');
  }

  return authContext;
};
